
import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk'; // Note: configureStore includes redux-thunk by default, so this import and middleware setup might be redundant.
import throttle from 'lodash/throttle';
import rootReducer from './reducers';
import { loadState, saveState } from './localStorage';

// Load the persisted state from localStorage
const persistedState = loadState();

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
    devTools: process.env.NODE_ENV !== 'production', // Enable Redux DevTools in development mode
    preloadedState: persistedState, // Initialize the store with the persisted state
});

// Subscribe to store changes and save the 'settings' slice to localStorage
store.subscribe(throttle(() => {
    saveState({
        settings: store.getState().settings, // Only persist the 'settings' slice
    });
}, 1000)); // Save at most once per second

export default store;
